import { Fragment, useContext, useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import { BackToTop } from "../Components/Common/backToTop";
import ScrollToTop from "../Components/Common/ScrollToTop";
import { SessionTime } from "../Components/Common/SessionTime";
import { CookiePreference } from "../Components/CookieSetting/cookiePreference";
import { ContactUSFloating } from "../Components/Footer/contactUsFloating";
import { CookieSettingsFloating } from "../Components/Footer/cookieSettingsFloating";
import { Footer } from "../Components/Footer/footer";
import { Header } from "../Components/Header/header";
import { CultureContext, ICultureContextType } from "../Context/cultureContext";
import { useLocation } from "react-router-dom";
export const Layout = () => {
  const [isHide, setIsHide] = useState<boolean>(true);

  useEffect(() => {
    if (isHide) {
      const timeout = setTimeout(() => setIsHide(false), 3000);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [isHide]);

  const location = useLocation();
  const currentPath = location.pathname;
  const shouldHideLayout = currentPath.includes("/toolbox-legal-notice");

  return (
    // added style attr because, to not show <Header /> and <Footer /> component after login in IFRAME
    <div style={{ display: isHide ? "none" : "block" }}>
      {!shouldHideLayout && <Header />}
      <Outlet />
      {!shouldHideLayout && <Footer />}
      {!shouldHideLayout && <BackToTop />}
      {!shouldHideLayout && <CookieSettingsFloating />}
      {!shouldHideLayout && <ContactUSFloating />}
      {!shouldHideLayout && <ScrollToTop />}
      <SessionTime />
      <CookiePreference />
    </div>
  );
};
